import {
    MDBBtn,
    MDBCheckbox,
    MDBCol,
    MDBContainer,
    MDBIcon,
    MDBInput,
    MDBModalFooter,
    MDBRow,
    MDBSelect,
    MDBSpinner,
    MDBTypography
} from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Tooltip } from 'react-tooltip';
import BrandDetails from '../../views/popups/globalaccount/brandAndSMS/BrandDetails';
import BrandContactDetails from '../../views/popups/globalaccount/brandAndSMS/BrandContactDetails';
import { useForm } from 'react-hook-form';
import { createBrand, registerTheBrand } from '../../apiclients/streamsapi_bridge';
function AddSMSBrand(props) {
    const prevRef = useRef(null);
    const nextRef = useRef(null);
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [registerBrand, setregisterBrand] = useState(false);

    const [verticalActive, setVerticalActive] = useState('tab1');
    const [visitedTabs, setVisitedTabs] = useState([]);
    const [isloading, setIsloading] = useState(false);

    const handleVerticalClick = (tab) => {
        setVerticalActive(tab);
        if (!visitedTabs.includes(tab)) {
            setVisitedTabs([...visitedTabs, tab]);
        }
    };

    const { register, setValue, handleSubmit, formState: { isDirty, dirtyFields, errors }, reset, clearErrors, setError, watch } = useForm({
        defaultValues: {
            brand_details: {
                city: "",
                state: "",
                street: "",
                country: "",
                website: "",
                zipcode: "",
                org_type: "",
                brand_name: "",
                tax_number: "",
                company_name: "",
                duns_giin_lei: "",
                duns_giin_lei_num: "",
                vertical_type: "",
                stock_exchange: "",
                stock_symbol: ""
            },
            contact_details: {
                phno: "",
                email: "",
                contact_name: ""
            },
        }
    });
    const handleNextClick = () => {
        const tabs = ['tab1', 'tab2', 'tab3', 'tab4'];
        const currentIndex = tabs.indexOf(verticalActive);
        if (currentIndex < tabs.length - 1) {
            setVerticalActive(tabs[currentIndex + 1]);
            if (!visitedTabs.includes(tabs[currentIndex + 1])) {
                setVisitedTabs([...visitedTabs, tabs[currentIndex + 1]]);
            }
        } else {
            props.nextPageclick();
        }
    };

    const handlePreviousClick = () => {
        const tabs = ['tab1', 'tab2', 'tab3', 'tab4'];
        const currentIndex = tabs.indexOf(verticalActive);
        if (currentIndex > 0) {
            setVerticalActive(tabs[currentIndex - 1]);
            if (visitedTabs.includes(tabs[currentIndex - 1])) {
                setVisitedTabs(visitedTabs.filter(tab => tab !== tabs[currentIndex]));
            }
        }
    };

    useEffect(() => {
        if (props.draftDetails && Object.keys(props.draftDetails).length > 0) {
            setValue('brand_details.city', props.draftDetails?.brand_details?.city ?? "");
            setValue('brand_details.state', props.draftDetails?.brand_details?.state ?? 0);
            setValue('brand_details.street', props.draftDetails?.brand_details?.street ?? "");
            setValue('brand_details.country', props.draftDetails?.brand_details?.country ?? "");
            setValue('brand_details.website', props.draftDetails?.brand_details?.website ?? "");
            setValue('brand_details.zipcode', props.draftDetails?.brand_details?.zipcode ?? 0);
            setValue('brand_details.org_type', props.draftDetails?.brand_details?.org_type.id ?? 0);
            setValue('brand_details.brand_name', props.draftDetails?.brand_details?.brand_name ?? "");
            setValue('brand_details.tax_number', props?.draftDetails?.brand_details?.tax_number ?? "");
            setValue('brand_details.company_name', props?.draftDetails?.brand_details?.company_name ?? "");
            setValue('brand_details.duns_giin_lei', props.draftDetails?.brand_details?.duns_giin_lei ?? "");
            setValue('brand_details.duns_giin_lei_num', props.draftDetails?.brand_details?.duns_giin_lei_num ?? 0);
            setValue('brand_details.vertical_type', props.draftDetails?.brand_details?.vertical_type?.id ?? 0);
            setValue('brand_details.stock_exchange', props.draftDetails?.brand_details?.stock_exchange ?? "");
            setValue('brand_details.stock_symbol', props.draftDetails?.brand_details?.stock_symbol ?? "");
            setValue('contact_details.phno', props.draftDetails?.contact_details?.phno ?? "");
            setValue('contact_details.email', props.draftDetails?.contact_details?.email ?? "");
            setValue('contact_details.contact_name', props.draftDetails?.contact_details?.contact_name ?? "");
            if (props?.draftDetails?.flow_step && props.draftDetails?.flow_step !== 0)
                setCurrentStep(parseInt(props?.draftDetails?.flow_step) - 1);
        }

    }, [props.draftDetails])



    const [formValue, setFormValue] = useState({
        fname: 'Mark',
        lname: 'Otto',
        email: '',
        city: '',
        state: '',
        zip: '',
    });

    const onChange = (e) => {
        setFormValue({ ...formValue, [e.target.name]: e.target.value });
    };

    const handleSubmits = () => {
        // Add your form submission logic here

        // After successful submission, change the active tab
        setVerticalActive('tab2'); // Change this to the desired tab value
    };
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const handleFileChange = (event) => {
        const files = event.target.files;
        const newUploadedFiles = [...uploadedFiles]; // Copy existing files

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileSizeInMB = file.size / (1024 * 1024); // Convert bytes to MB

            if (fileSizeInMB <= 25) { // Check if file size is within limit
                newUploadedFiles.push(file.name);
            } else {
                alert(`File '${file.name}' exceeds the maximum file size of 25 MB.`);
            }
        }

        setUploadedFiles(newUploadedFiles);
    };

    const handleDeleteFile = (index) => {
        const newUploadedFiles = [...uploadedFiles];
        newUploadedFiles.splice(index, 1);
        setUploadedFiles(newUploadedFiles);
    };

    const steps = ['Brand Details', 'Contact Details'];
    const [currentStep, setCurrentStep] = useState(0);

    const handleNext = async (data) => {
        let finalUpdate = {};

        console.log("dirtyFields:", JSON.stringify(dirtyFields));
        console.log("data:", JSON.stringify(data));
        setIsloading(true);

        if (currentStep === 0) {
            const { brand_details: keys } = dirtyFields;
            const { brand_details: keysData } = data;
            let modifiedData = {};

            if (!Array.isArray(keysData)) {
                modifiedData = Object.fromEntries(
                    Object.keys(keys).map(field => [field, keysData[field]])
                );
            } else {
                modifiedData = [...keysData];
            }

            finalUpdate = { brand_details: modifiedData };
        } else {
            finalUpdate = extractModifiedFields(dirtyFields, data);
        }

        if (Object.keys(finalUpdate).length > 0) {
            const session = JSON.parse(sessionStorage.getItem("admin_session"));
            finalUpdate = {
                ...finalUpdate,
                reqid: 107,
                siteid: session.siteid,
                flow_step: currentStep + 1,
                ...(currentStep === 1 && { submit_type: 1 })
            };

            console.log("final request :::::::::::::::: " + JSON.stringify(finalUpdate));

            const response = await createBrand(finalUpdate);

            const responseMsg = await response.json();
            console.log("Response:", responseMsg);
            setIsloading(false);

            if (responseMsg.status === "success") {

                if (currentStep === 1) {
                    localStorage.setItem("s_message", responseMsg.message);
                    window.location.href = "/smslanding";

                } else {
                    setCurrentStep(currentStep + 1);
                }
            } else if (responseMsg.message?.errors) {
                responseMsg.message.errors.forEach(({ param_name, message }) => {
                    setError(param_name, { type: "server", message });
                    const fieldElement = document.querySelector(`input[name="${param_name}"]`);
                    fieldElement?.focus();
                    fieldElement?.scrollIntoView({ behavior: "smooth" });
                });
            }
        }
    };

    function extractModifiedFields(dirtyFields, data) {
        const modifiedData = {};

        function recurse(dirtyFields, data, modifiedData) {
            for (const field of Object.keys(dirtyFields)) {
                if (dirtyFields[field] && data.hasOwnProperty(field)) {
                    if (typeof data[field] === "object" && !Array.isArray(data[field])) {
                        modifiedData[field] = {};
                        recurse(dirtyFields[field], data[field], modifiedData[field]);
                    } else {
                        modifiedData[field] = data[field];
                    }
                }
            }
        }

        recurse(dirtyFields, data, modifiedData);
        return modifiedData;
    }
    const handleBack = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };
    const handleReset = () => {
        setCurrentStep(0);
    };

    const stepContent = [
        <>
            <BrandDetails
                register={register}
                watch={watch}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                isLoading={isloading}
                setIsLoading={setIsloading}
            />
        </>,
        <>
            <BrandContactDetails
                register={register}
                watch={watch}
                errors={errors}
                setValue={setValue}
            />

        </>
    ]

    const [isFirstPage, setisFirstPage] = useState(false);

    async function handleRegister(e) {
        e.preventDefault();
        try {
            const finalUpdate = {
                reqid: 123,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")),
                accept_terms: registerBrand,
            };

            const response = await registerTheBrand(finalUpdate);
            const responseMsg = await response.json();
            console.log("Response:", responseMsg);

            if (responseMsg.status === "success") {
                setisFirstPage(false);
            } else if (responseMsg.message?.errors) {
                responseMsg.message.errors.forEach(({ param_name, message }) => {
                    setError(param_name, { type: "server", message });
                    const fieldElement = document.querySelector(`input[name="${param_name}"]`);
                    fieldElement?.focus();
                    fieldElement?.scrollIntoView({ behavior: "smooth" });
                });
            }

        } catch (error) {

        }
    }

    async function handleDraft(data) {

        let finalUpdate = {};

        console.log("dirtyFields:", JSON.stringify(dirtyFields));
        console.log("data:", JSON.stringify(data));
        setIsloading(true);

        finalUpdate = extractModifiedFields(dirtyFields, data);


        if (Object.keys(finalUpdate).length > 0) {
            const session = JSON.parse(sessionStorage.getItem("admin_session"));
            finalUpdate = {
                ...finalUpdate,
                reqid: 107,
                siteid: session.siteid,
                flow_step: currentStep + 1,
                submit_type: 2,
            };

            console.log("final request :::::::::::::::: " + JSON.stringify(finalUpdate));

            const response = await createBrand(finalUpdate);

            const responseMsg = await response.json();
            console.log("Response:", responseMsg);
            setIsloading(false);

            if (responseMsg.status === "success") {

                localStorage.setItem("s_message", responseMsg.message);
                window.location.href = "/smslanding";

            } else if (responseMsg.message?.errors) {
                responseMsg.message.errors.forEach(({ param_name, message }) => {
                    setError(param_name, { type: "server", message });
                    const fieldElement = document.querySelector(`input[name="${param_name}"]`);
                    fieldElement?.focus();
                    fieldElement?.scrollIntoView({ behavior: "smooth" });
                });
            }
        }

    }
    return (
        <>
            <div className="stepper-container">
                <MDBContainer>
                    {isFirstPage ?
                        <>
                            <div className='SmsStepOne'>
                                <p className='mb-4'>
                                    First time Brand(Company) Registration
                                </p>
                                <MDBTypography className='mb-4' tag='u'>This line of text will render as underlined</MDBTypography>
                                <MDBTypography className='mb-4' tag='u'>Terms of Use</MDBTypography>

                                <p className='text-danger mb-4'>
                                    Note : To continue, "Agree" to the mentioned "Terms of Use". Click "Terms of Use" button to read the terms of use carefully before you "Agree" to it.
                                </p>


                                <MDBCheckbox
                                    id='controlledCheckbox'
                                    label='I agree to the terms of use'
                                    checked={registerBrand}
                                    onChange={(e) => setregisterBrand(e.target.checked)}
                                />
                                <MDBBtn className='mt-4' disabled={!registerBrand} onClick={(e) => handleRegister(e)}>Continue</MDBBtn>
                            </div>
                        </> :
                        <>
                            <div className="stepper">
                                {steps.map((step, index) => (
                                    <>
                                        <div
                                            key={index}
                                            className={`step ${index <= currentStep ? 'active' : ''}`}
                                        >
                                            <div className="step-number">{index + 1}</div>
                                            <div className="step-label ms-2">{step}</div>
                                        </div>
                                    </>
                                ))}
                            </div>

                            <div className="stepper-contentsms overflow-y-auto px-4 ">
                                {stepContent[currentStep]}
                            </div>
                        </>
                    }
                </MDBContainer>
                {!isFirstPage && (
                    <MDBModalFooter className='w-100 justify-content-start'>
                        <div>
                            <p className='red text-left'>Note: It is extremely important that all information submitted be accurate, as incorrect data will delay processing and can result in rejection.</p>
                        </div>
                        <div className='d-flex justify-content-between w-100 flex-row'>
                            <MDBBtn color='secondary' className="text-normal-case" onClick={(e) => { e.preventDefault(); handleSubmit(handleDraft)() }}>
                                Save to Draft
                            </MDBBtn>
                            <div className="text-end">
                                <MDBBtn color='secondary' className='me-2' onClick={handleBack} disabled={currentStep === 0}>
                                    Back
                                </MDBBtn>
                                <MDBBtn onClick={(e) => { e.preventDefault(); handleSubmit(handleNext)() }}>Next</MDBBtn>
                            </div>
                        </div>
                    </MDBModalFooter>

                )}
                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}

            </div>
        </>
    )
}
export default AddSMSBrand